import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { categoryApi, addCategoryApi, updateCategoryApi, updateCategoryImageApi } from "store/api";
import EditIcon from "@mui/icons-material/Edit";

import { Button, Grid, IconButton, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import { Add, Delete, DeleteRounded, Edit, EditRounded, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import UpdateCategory from "../UpdateCategory";
import AddCategory from "../AddCategory";
import axios from "axios";
import Success from "components/Success";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Label } from "@mui/icons-material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { deleteCategoryApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CategoryTab () {
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [category, setCategory] = React.useState([]);
  const [updateCategory, setUpdateCategory] = React.useState({});
  const [addCategoryImage, setAddCategoryImage] = React.useState({});
  const [updateCategoryImage, setUpdateCategoryImage] = React.useState({});
  const [addCategory, setAddCategory] = React.useState({
    nameEn: "",
    nameUz: "",
    slug: "",
    image: "",
    categoryOrder: 0,
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClickOpenUpdate = data => {
    setUpdateCategory(data);
    setOpenUpdate(true);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    //   setOpen(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchCategory = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await categoryApi(params);
      if (response?.success) {
        setCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeCategory = async e => {
    const { value } = e.target;
    // Clear the previous timeout
    if (debounceTimeout) clearTimeout(debounceTimeout);
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      FetchCategory(value);
    }, 500); // Adjust debounce delay (500ms)

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    delete updateCategory.image;
    const response = await updateCategoryApi(updateCategory);
    if (response?.success) {
      if (updateCategoryImage?.image) {
        let data = {
          categoryId: updateCategory?.categoryId,
        };
        const getImage = await updateCategoryImageApi(data);
        if (getImage?.success) {
          let uploadUrl = getImage?.data?.uploadUrl;
          const uploadResponse = await axios.put(uploadUrl, updateCategoryImage?.image, {
            headers: { "Content-Type": updateCategoryImage?.image?.type },
          });
          if (uploadResponse?.status) {
            let data = {
              categoryId: updateCategory?.categoryId,
              image: getImage?.data?.fileUrl,
            };
            const res = await updateCategoryApi(data);
            if (res?.success) {
              setMsg("Update Category Successfully");
              setSuccess(true);
              FetchCategory();
              setOpenUpdate(false);
              setOpen(true);
              setUpdateCategoryImage({});
            } else {
              setOpen(true);
              setOpenAdd(false);
              setSuccess(false);
              setMsg("Something went wrong in upload image. Please try again later.");
            }
          } else {
            setOpen(true);
            setOpenAdd(false);
            setSuccess(false);
            setMsg("Something went wrong in upload image. Please try again later.");
          }
        } else {
          setOpen(true);
          setOpenAdd(false);
          setSuccess(false);
          setMsg("Something went wrong. Please try again later.");
        }
      } else {
        setMsg("Update Category Successfully");
        setSuccess(true);
        FetchCategory();
        setOpenUpdate(false);
        setOpen(true);
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleSubmitAdd = async e => {
    e?.preventDefault();
    const response = await addCategoryApi(addCategory);
    if (response?.success) {
      let uploadUrl = response?.data?.uploadUrl;
      const uploadResponse = await axios.put(uploadUrl, addCategoryImage?.image, {
        headers: { "Content-Type": addCategoryImage?.image?.type },
      });
      if (uploadResponse?.status) {
        let data = {
          categoryId: response?.data?.categoryDetails?.categoryId,
          image: response?.data?.fileUrl,
        };
        const res = await updateCategoryApi(data);
        if (res?.success) {
          setMsg("Add Category Successfully");
          setSuccess(true);
          FetchCategory();
          setOpenAdd(false);
        } else {
          setSuccess(false);
          setMsg("Something went wrong. Please try again later.");
        }
        setOpen(true);
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleChangeUpdateCategory = e => {
    const { name, value } = e.target;
    setUpdateCategory(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeAddCategory = e => {
    const { name, value } = e.target;
    setAddCategory(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeAddCategoryImage = e => {
    const { name, value } = e.target;
    setAddCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
  };
  const handleChangeUpdateCategoryImage = e => {
    const { name, value } = e.target;
    setUpdateCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
  };

  const DeleteCategory = async categoryId => {
    const params = {
      categoryId: categoryId,
    };
    const response = await deleteCategoryApi(params);
    if (response?.success) {
      setMsg("Delete Category Successfully");
      setSuccess(true);
      FetchCategory();
      setOpenAdd(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  React.useEffect(() => {
    FetchCategory();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Category</Typography>
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Add New
        </Button>
      </div>

      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCategory}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Category' {...a11yProps(0)} />
            <Tab label='Active Category' {...a11yProps(1)} />
            <Tab label='Disable Category' {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No Category found</div>}
            {category?.length > 0 &&
              category?.map(e => (
                <Category
                  category={e}
                  DeleteCategory={DeleteCategory}
                  handleClickOpenUpdate={handleClickOpenUpdate}
                />
              ))}
          </Grid2>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No Category found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No Category found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  !e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
      </Box>
      <UpdateCategory
        open={openUpdate}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateCategoryData={updateCategory}
        updateCategoryImage={updateCategoryImage}
        handleChangeUpdateCategory={handleChangeUpdateCategory}
        handleChangeUpdateCategoryImage={handleChangeUpdateCategoryImage}
      />
      <AddCategory
        open={openAdd}
        handleClose={handleCloseAdd}
        addCategoryData={addCategory}
        handleSubmit={handleSubmitAdd}
        addCategoryImage={addCategoryImage}
        handleChangeAddCategory={handleChangeAddCategory}
        handleChangeAddCategoryImage={handleChangeAddCategoryImage}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}

const Category = ({ category, DeleteCategory, handleClickOpenUpdate }) => {
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card>
        <Box sx={{ pt: "100%", position: "relative" }}>
          <div
            style={{
              zIndex: 9,
              top: 10,
              right: 10,
              position: "absolute",
              textTransform: "uppercase",
              display: "flex",
              gap: "10px",
            }}
          >
            <Tooltip title={"Delete"} onClick={() => DeleteCategory(category?.categoryId)}>
              {/* <IconButton > */}
              <DeleteRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
              {/* </IconButton> */}
            </Tooltip>
            <Tooltip title={"Edit"} onClick={() => handleClickOpenUpdate(category)}>
              {/* <IconButton > */}
              <EditRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
              {/* </IconButton> */}
            </Tooltip>
          </div>

          <Box
            component='img'
            alt='category'
            src={category.image}
            sx={{
              top: 0,
              width: 1,
              height: 1,
              zIndex: 0,
              objectFit: "cover",
              position: "absolute",
              borderRadius: "16px 16px 0 0",
            }}
          />
        </Box>

        <Stack spacing={2} sx={{ p: 3 }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500" }}
            noWrap
          >
            {category?.nameEn}
            <br />
            {category?.nameUz}
          </Box>

          <Box display='flex' alignItems='center' justifyContent='space-between'>
            {/* <Box class='MuiBox-root css-udwogp'>
              {category?.colors?.map((e, i) => (
                <Box
                  className={`MuiBox-root ${
                    i == 0 ? "css-1r15jgt" : i == 1 ? "css-1ebeuj6" : i == 2 ? "css-16couxa" : ""
                  }`}
                  style={{ backgroundColor: e.colorCode }}
                >
                </Box>
              ))}
            </Box> */}
            {/* <ColorPreview colors={category.colors} /> */}
            <Typography variant='subtitle1' style={{ fontSize: "0.875rem", fontWeight: "500" }}>
              {category?.discountPrice}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
